export const homeRoutes = [
  {
    path: '/',
    name: 'home',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "login" */ './Home.vue')
  }
];
